import { Label } from '@core-web/ui';
import * as S from './PageFormInput.styled';
import { IPageFormInput } from './IPageFormInput';

export const PageFormInput = (props: IPageFormInput): JSX.Element => {
  const { label, hideLabel, icon, required, children, disableFixedHeight } = props;

  return (
    <S.Wrapper>
      {!hideLabel && (
        <S.LeftSection>
          <Label label={label || ''} sx={S.LabelStyle} required={required}></Label>
          {icon && <S.IconWrapper>{icon}</S.IconWrapper>}
        </S.LeftSection>
      )}
      <S.CenterSection disableFixedHeight={disableFixedHeight}>{children}</S.CenterSection>
    </S.Wrapper>
  );
};
export const PageFormEmailListInput = ({ label, children }: IPageFormInput): JSX.Element => {
  return (
    <S.PageFormEmailListInputWrapper>
      <S.EmailListLabel>{label}</S.EmailListLabel>
      <S.EmailListInput>{children}</S.EmailListInput>
    </S.PageFormEmailListInputWrapper>
  );
};

export default PageFormInput;
